import React from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import { useGetCompaniesCountByRegionQuery } from '../../redux/slices/visualisationSlice';
import Loader from '../Loader';
import ErrorAlert from '../ErrorAlert';
import { useGetCompaniesQuery } from '../../redux/slices/companiesSlice';
import { useGetRegionsQuery } from '../../redux/slices/regionsSlice';


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)


const CompaniesByRegion = () => {

    const { data: regions, isLoading: isLoadingRegions, isSuccess: isSuccessRegions, isError: isErrorRegions, error: errorRegions } = useGetRegionsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    })

    const { data: companies, isLoading: isLoadingCompanies, isSuccess: isSuccessCompanies, isError: isErrorCompanies, error: errorCompanies } = useGetCompaniesQuery(undefined, {
        refetchOnMountOrArgChange: true,
    })

    let content;


    if (isLoadingRegions || isLoadingCompanies) {
        content = (
            <Loader />
        )
    } else if (isSuccessCompanies && companies && isSuccessRegions && regions) {

        // console.log('companies', companies);

        // console.log('regions', regions);

        const mergeArrays = (companies) => {
            let finalArray: any[] = [];
            let count = {};

            for (let i = 0; i < companies.length; i++) {
                let company = companies[i];

                finalArray.push({
                    name: company.name,
                    region: company.region
                });

                if (!count[company.region]) {
                    count[company.region] = 1;
                } else {
                    count[company.region]++;
                }
            }

            return {
                finalArray: finalArray,
                count: count
            };
        };

        let merged = mergeArrays(companies);

        // console.log('merged', merged);

        let finalData: any[] = []

        Object.keys(merged.count).forEach(key => {
            finalData.push({
                label: key,
                value: merged.count[key],
            })
        })

        const options = {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Companies by Region',
                },
            },
        };

        const data = {
            labels: finalData.map((d) => { return d.label }),
            datasets: [
                {
                    label: 'Companies',
                    data: finalData.map((d) => { return d.value }),
                    backgroundColor: ['#ffc700', '#333', '#AAA'],
                },
            ],
        };



        content = (
            <Bar options={options} data={data} />
        )
    } else if (isErrorCompanies || isErrorRegions) {
        content = (
            <ErrorAlert title="Error Loading Company Region Stats!" error={JSON.stringify(errorCompanies, null, 2)} />
        )
    } else {
        content = (
            <Loader />
        )
    }

    return content;
}

export default CompaniesByRegion
